export default {
  name: '课程管理',
  path: 'course',
  component: () => import(/* webpackChunkName: "course" */'@/views/course/Index'), // require('@/views/course/Index'),
  redirect: 'course/group',
  children: [
    {
      name: '团课管理',
      path: 'group',
      component: () => import(/* webpackChunkName: "course" */'@/views/course/group'),
      redirect: 'group/course',
      children: [
        {
          name: '团课课程',
          path: 'course',
          component: () => import(/* webpackChunkName: "course" */'@/views/course/group/course/Index'),
          redirect: 'course/list',
          children: [
            {
              name: '课程列表',
              path: 'list',
              component: () => import(/* webpackChunkName: "course" */'@/views/course/group/course/List'),
              // component: (resolve) => { require(['@/views/course/group/course/List'], resolve) },
              meta: {
                activePath: '/main/course/group',
                button: {
                  text: ' + 团课课程',
                  path: 'add'
                }
              }
            },
            {
              name: '添加团课课程',
              path: 'add',
              component: () => import(/* webpackChunkName: "course" */'@/views/course/group/course/Edit'),
              meta: {
                activePath: '/main/course/group'
              }
            },
            {
              name: '编辑团课课程',
              path: 'edit',
              component: () => import(/* webpackChunkName: "course" */'@/views/course/group/course/Edit'),
              meta: {
                activePath: '/main/course/group'
              }
            }
          ]
        }, {
          name: '团课课表',
          path: 'schedule',
          component: () => import(/* webpackChunkName: "course" */'@/views/course/group/schedule/Index'),
          redirect: 'schedule/list',
          children: [
            {
              name: '团课排期',
              path: 'list',
              component: () => import(/* webpackChunkName: "course" */'@/views/course/group/schedule/List'),
              meta: {
                activePath: '/main/course/group',
                button: {
                  text: ' + 添加排期',
                  path: 'add'
                }
              }
            }, {
              name: '添加团课排期',
              path: 'add',
              component: () => import(/* webpackChunkName: "course" */'@/views/course/group/schedule/Edit'),
              meta: {
                activePath: '/main/course/group'
              }
            }, {
              name: '编辑团课排期',
              path: 'edit',
              component: () => import(/* webpackChunkName: "course" */'@/views/course/group/schedule/Edit'),
              meta: {
                activePath: '/main/course/group'
              }
            }, {
              name: '查看团课排期',
              path: 'view',
              component: () => import(/* webpackChunkName: "course" */'@/views/course/group/schedule/View'),
              meta: {
                activePath: '/main/course/group'
              }
            }
          ]
        }
      ]
    },
    {
      name: '私教管理',
      path: 'personal',
      component: () => import(/* webpackChunkName: "course" */'@/views/course/personal/Index'),
      redirect: 'personal/schedule',
      children: [
        {
          name: '私教课表',
          path: 'schedule',
          component: () => import(/* webpackChunkName: "course" */'@/views/course/personal/Schedule')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/course/index.js